import {
  CreateRailTrackRequest,
  RailTrackResponse,
  RailTracksApi,
  UpdateRailTrackRequest,
} from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

export class RailTrackService {
  private readonly httpClient = createApiClient(RailTracksApi)

  async list(): Promise<RailTrackResponse[]> {
    const { data } = await this.httpClient.getRailTracks()

    return data.railTracks
  }

  async create(request: CreateRailTrackRequest): Promise<string> {
    const { data } = await this.httpClient.createRailTrack(request)
    return data.id
  }

  async update(request: UpdateRailTrackRequest): Promise<void> {
    await this.httpClient.updateRailTrack(request)
  }

  async delete(id: string): Promise<void> {
    await this.httpClient.deleteRailTrack({ id })
  }
}

export const railTrackService = new RailTrackService()
